import { cn } from '@/lib/utils'
import { LoaderCircleIcon, LucideProps } from 'lucide-react'

type SpinnerProps = {
	className?: string
} & Pick<LucideProps, 'size'>

/**
 * SVG spinner component
 */
function Spinner({ className, size = 24 }: SpinnerProps) {
	return <LoaderCircleIcon className={cn('text-elements-neutral-subtle animate-spin', className)} size={size} />
}

export { Spinner, type SpinnerProps }
